import type { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import Checkbox from '@components/Checkbox/Checkbox';

/**
 * VITALL-styled checkbox component for the routine form
 */
const BooleanEditor = ({ ...props }: AppointmentForm.BooleanEditorProps) => {
  const { label, value, onValueChange } = props;
  return (
    <Checkbox
      checked={value ?? false}
      defaultChecked={value ?? false}
      label={label}
      onChange={(event) => onValueChange(event.target.checked)}
    />
  );
};

export default BooleanEditor;
